<template>
<div class="home guide-page page-template-default page page-id-download wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="download" />

  <GuideBreadcrumb :items="[{ label: 'Home', href: '/' }, { label: 'Download' }]" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">

          <section class="entry-wrapper hero">
            <div class="hero-shell hero-shell--download">
              <header class="hero-top">
                <p class="hero-kicker">APK Download · v18.80</p>
                <h1>Download GB WhatsApp Pro APK</h1>
              </header>

              <div class="hero-cta">
                <div class="hero-logo-wrap">
                  <img class="hero-logo" src="@/assets/gbwa-logo.webp" alt="GB WhatsApp logo">
                </div>
                <a
                  class="hero-download-btn"
                  :href="apk"
                  rel="noopener noreferrer"
                  @click="onDownloadClick"
                >
                  <img class="hero-download-icon" src="@/assets/android.webp" alt="" aria-hidden="true">
                  <span>Download GB WhatsApp Pro APK</span>
                </a>
              </div>
            </div>
          </section>

          <div class="section-content">
            <h2 class="h">APK File Access</h2>
            <p>
              The installation package is available below. Users may obtain the file and install it manually if their device supports APK installation.
            </p>
            <div class="details-table">
              <table>
                <tbody>
                  <tr v-for="(row, i) in appDetails" :key="i">
                    <th>{{ row.label }}</th>
                    <td>
                      <a v-if="row.href" :href="row.href">{{ row.value }}</a>
                      <template v-else>{{ row.value }}</template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="section-content">
            <h2 class="h">Installation Notes</h2>
            <p>Before installing the APK file, please review the following points:</p>
            <ul class="check-list">
              <li v-for="(note, i) in installNotes" :key="i">{{ note }}</li>
            </ul>
          </div>

          <div v-for="(block, bi) in downloadSections" :key="'dl-' + bi" class="section-content">
            <h2 class="h">{{ block.h2 }}</h2>
            <p v-for="(p, pi) in block.paragraphs || []" :key="pi" v-html="p" />
            <ul v-if="block.list" class="check-list">
              <li v-for="(item, li) in block.list" :key="li" v-html="item" />
            </ul>
            <ol v-if="block.steps" class="step-cards">
              <li v-for="(step, si) in block.steps" :key="si">{{ step }}</li>
            </ol>
          </div>

          <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/gb-home-layout.scss';
import '@/css/guide-pages.scss';
import HeadNav from '@/components/HeadNav.vue';
import GuideBreadcrumb from '@/components/GuideBreadcrumb.vue';
import { CURRENT_APK_SIZE_LABEL, CURRENT_APK_URL } from '@/constants/apkVersions';
import { downloadSections } from '@/data/downloadPage';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,
      // 下载页固定使用需求指定的 APK，不依赖接口异步回填
      apk: CURRENT_APK_URL,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
      appDetails: [
        { label: 'App Name', value: 'GB WhatsApp Pro', href: '/' },
        { label: 'Version', value: 'v18.80' },
        { label: 'File Type', value: 'APK' },
        { label: 'File Size', value: CURRENT_APK_SIZE_LABEL },
        { label: 'Android Requirement', value: 'Android 5.0+' },
        { label: 'Category', value: 'Communication' },
      ],
      installNotes: [
        'Make sure your device supports APK installation.',
        'Enable installation from unknown sources if required.',
        'Check available device storage before installing.',
        'Backup existing chat data if necessary.',
      ],
      downloadSections,
    };
  },
  components: {
    HeadNav,
    GuideBreadcrumb,
  },
  methods: {
    onDownloadClick() {
      this.$logEvent('download_from_download_page', 'download');
    },
    download() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>

<!-- 下载页 Hero 与首页共用 gb-home-layout；此处 scoped 保证懒加载路由下样式一定生效 -->
<style lang="scss" scoped>
.hero-shell--download {
  grid-template-columns: minmax(0, 1fr);
  grid-template-areas:
    'top'
    'cta';
  justify-items: center;
  width: 100%;
  max-width: var(--content-max, 1120px);
  row-gap: clamp(18px, 2.2vw, 24px);
}

.hero-top {
  width: 100%;
}

.hero-top h1 {
  white-space: nowrap;
  text-wrap: nowrap;
  font-size: clamp(1.25rem, 0.65rem + 2.6vw, 2.75rem) !important;
  line-height: 1.15 !important;
  margin-bottom: 0 !important;
}

.hero-shell--download .hero-cta {
  width: 100%;
  max-width: 420px;
  padding: 0 !important;
  gap: clamp(16px, 2vw, 22px);
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

.hero-shell--download .hero-logo-wrap {
  width: clamp(120px, 18vw, 152px);
}

a.hero-download-btn {
  text-decoration: none !important;
}

@media (max-width: 768px) {
  .hero-top h1 {
    font-size: clamp(1rem, 0.45rem + 3.8vw, 1.9375rem) !important;
  }
}
</style>
